module.exports = __webpack_public_path__ + "img/jobshark-candidate-stages.dde186bb.jpg";